import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { MwProjectsApiService } from 'app/services/projects-api.service';
import * as projectsActions from 'app/store/temporary/actions/projects.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import * as notifyActions from 'app/store/general/actions/notify.actions';

@Injectable()
export class ProjectsEffects {
  loadProjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(projectsActions.loadProjects),
      switchMap(({ loadOptions }) =>
        this.projectsApiService.getProjects(loadOptions).pipe(
          map((response) => projectsActions.loadProjectsSuccess({ response })),
          catchError((error) =>
            of(projectsActions.loadProjectsFailed({ error }))
          )
        )
      )
    )
  );

  createProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(projectsActions.createProject),
      switchMap(({ project }) =>
        this.projectsApiService.createProject(project).pipe(
          switchMap(() => [
            projectsActions.createProjectSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_project_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(projectsActions.createProjectFailed({ error }))
          )
        )
      )
    )
  );

  updateProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(projectsActions.updateProject),
      switchMap(({ project }) =>
        this.projectsApiService.updateProject(project).pipe(
          switchMap((response) => [
            projectsActions.updateProjectSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.edit_project_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(projectsActions.updateProjectFailed({ error }))
          )
        )
      )
    )
  );

  deleteProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(projectsActions.deleteProject),
      switchMap(({ project }) =>
        this.projectsApiService.deleteProject(project).pipe(
          switchMap(() => [
            projectsActions.deleteProjectSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_project_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(projectsActions.deleteProjectFailed({ error }))
          )
        )
      )
    )
  );

  deleteProjectsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(projectsActions.deleteProjectsList),
      switchMap(({ projects }) =>
        this.projectsApiService.deleteProjectsList(projects).pipe(
          switchMap(() => [
            projectsActions.deleteProjectsListSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_projects_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(projectsActions.deleteProjectsListFailed({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private projectsApiService: MwProjectsApiService
  ) {}
}
